import AttachFileIcon from "@mui/icons-material/AttachFile";
import PhotoSizeSelectActualIcon from "@mui/icons-material/PhotoSizeSelectActual";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { number, object, string } from "yup";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import DropzoneByClick from "../../components/dropzone/DropzoneByClick";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { WHITELIST_TEMPLATES } from "../../config/cacheKey";
import {
  GetWhiteListLoanTemplatesResponse,
  RegisterWhiteListCustomerRequest,
} from "../../models/loanTemplateWhiteList.model";
import {
  GetWhiteListLoanTemplates,
  RegisterWhiteListCustomer,
} from "../../services/loanTemplateWhiteList.service";
import { CacheProvider } from "@emotion/react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

const AddCostumerToWhitelist = () => {
  const [selectFacilities, setSelectFacilities] = useState<number>();
  const [facilities, setFacilities] = useState<
    GetWhiteListLoanTemplatesResponse[]
  >();
  const [letterImage, setLetterImage] = useState<any>("");
  let inputRef = useRef<HTMLInputElement>(null);

  const history = useHistory();
  const theme = createTheme({
    direction: "rtl",
  });
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const initialValues: RegisterWhiteListCustomerRequest = {
    loanTemplateId: 0,
    customerNationalCode: "",
    customerFirstName: "",
    customerLastName: "",
    companyName: "",
    monthlyRepaymentPower: undefined,
    file: "",
  };

  function parseStringNumber(value: number, originalValue: string) {
    const parsedVal = Number(String(originalValue).replace(/,/g, ""));
    return parsedVal;
  }
  const validationSchema = object().shape({
    companyName: string()
      .ensure()
      .required("لطفا نام سازمان را وارد نمایید"),
    customerNationalCode: string()
      .ensure()
      .required("لطفا کد ملی را وارد نمایید")
      .matches(/^\d+$/, "لطفا کد ملی را صحیح وارد نمایید"),
    customerFirstName: string()
      .ensure()
      .required("لطفا نام را وارد نمایید"),
    customerLastName: string()
      .ensure()
      .required("لطفا نام خانوادگی را وارد نمایید"),
    monthlyRepaymentPower: number()
      .integer()
      .transform(parseStringNumber)
      .required("فیلد اجباری است."),
  });

  useQuery<GetWhiteListLoanTemplatesResponse[]>(
    WHITELIST_TEMPLATES,
    GetWhiteListLoanTemplates,
    {
      onSuccess(data) {
        if (data) {
          setFacilities(data);
        }
      },
    }
  );


  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
  };

  const { mutate: RegisterWhiteListCustomerMutation } = useMutation(
    RegisterWhiteListCustomer,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success("مجوز اهدا تسهیلات با موفقیت انجام شد");
          history.push("/license/WhiteListHistory");
        }
      },
      onError: () => { },
    }
  );

  const handleSubmit = (values: RegisterWhiteListCustomerRequest) => {
    values.loanTemplateId = selectFacilities!;
    values.file = letterImage;

    RegisterWhiteListCustomerMutation(values);
  };

  const selectLogo = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  function handleChoosedImage(image: any) {
    if (image.length !== 0) {
      if (image[0].size > 1000 * 1000) {
        toast.error("حجم فایل آپلودی نباید بیش از 1 مگابایت باشد");
      } else {
        setLetterImage(image[0]);
      }
    }
  }

  return (
    <>
      <Box
        width={"100%"}
        height={{
          xs: "fit-content",
          sm: "fit-content",
          md: "95vh",
          lg: "85vh",
        }}
        border={"2px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
        position={"relative"}
      >
        <Typography
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-40px",
            marginRight: "23px",
            background: "#fff",
            marginBottom: "25px",
          }}
        >
          ثبت مجوز اهدای تسهیلات
        </Typography>
        <Grid container>
          <Grid item xs={12} sm={12} md={10} lg={6}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnMount={true}
              validationSchema={validationSchema}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container direction={"column"}>
                    <Grid item>
                      <Grid container>
                        <Grid item xs={12} paddingX={"10px"}>
                          <DropdownCmp2
                            style={{
                              paddingRight: "0 !important",
                            }}
                            onChange={(e: any) =>
                              setSelectFacilities(e.target.value)
                            }
                            onBlur={handleBlur}
                            value={selectFacilities}
                            label={"انتخاب طرح تسهیلات*"}
                            options={facilities}
                            name="facilities"
                            id="facilities"
                          />
                        </Grid>
                        <Grid item xs={12} paddingX={"10px"} marginY={"20px"}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام سازمان"}
                            label={"نام سازمان"}
                            required={true}
                            name="companyName"
                            id="companyName"
                            helperText={
                              touched.companyName ? errors.companyName : ""
                            }
                            error={
                              touched.companyName && Boolean(errors.companyName)
                            }
                            onChange={handleChange}
                            value={values.companyName}
                            onBlur={handleBlur}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid container>
                        <Grid item xs={6} paddingX={"10px"}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام"}
                            label={"نام"}
                            required={true}
                            name="customerFirstName"
                            id="customerFirstName"
                            helperText={
                              touched.customerFirstName
                                ? errors.customerFirstName
                                : ""
                            }
                            error={
                              touched.customerFirstName &&
                              Boolean(errors.customerFirstName)
                            }
                            onChange={handleChange}
                            value={values.customerFirstName}
                            onBlur={handleBlur}
                          />
                        </Grid>
                        <Grid item xs={6} paddingX={"10px"}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام خانوادگی"}
                            label={"نام خانوادگی"}
                            required={true}
                            name="customerLastName"
                            id="customerLastName"
                            helperText={
                              touched.customerLastName
                                ? errors.customerLastName
                                : ""
                            }
                            error={
                              touched.customerLastName &&
                              Boolean(errors.customerLastName)
                            }
                            onChange={handleChange}
                            value={values.customerLastName}
                            onBlur={handleBlur}
                          />
                        </Grid>
                        <Grid item xs={6} paddingX={"10px"} marginY={"20px"}>
                          <MaterialTextFieldComponent
                            placeHolder={"کد ملی متقاضی"}
                            label={"کد ملی متقاضی"}
                            required={true}
                            inputProps={{ maxLength: 10 }}
                            name="customerNationalCode"
                            id="customerNationalCode"
                            helperText={
                              touched.customerNationalCode
                                ? errors.customerNationalCode
                                : ""
                            }
                            error={
                              touched.customerNationalCode &&
                              Boolean(errors.customerNationalCode)
                            }
                            onChange={handleChange}
                            value={values.customerNationalCode}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                          />
                        </Grid>
                        <Grid item xs={6} paddingX={"10px"} marginY={"20px"}>
                          <CacheProvider value={cacheRtl}>
                            <ThemeProvider theme={theme}>
                              <PriceFeildComponent
                                showPersianWords={true}
                                label={"*توان بازپرداخت (ریال)"}
                                placeHolder={"توان بازپرداخت ماهیانه"}
                                required={true}
                                value={
                                  values.monthlyRepaymentPower === undefined
                                    ? ""
                                    : values.monthlyRepaymentPower.toLocaleString()
                                }
                                name="monthlyRepaymentPower"
                                id="monthlyRepaymentPower"
                                onChange={handleChange}
                                // onChange={handleSelectedMonthlyIncome}
                                onBlur={handleBlur}
                                helperText={
                                  touched.monthlyRepaymentPower
                                    ? errors.monthlyRepaymentPower
                                    : ""
                                }
                                error={
                                  touched.monthlyRepaymentPower &&
                                  Boolean(errors.monthlyRepaymentPower)
                                }
                                onKeyDown={handleKeyDown}
                              />
                            </ThemeProvider>
                          </CacheProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      paddingX={"10px"}
                      sx={{ cursor: "pointer" }}
                      marginY={"10px"}
                    >
                      {!letterImage ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            width: "200px",
                            height: "120px",
                            border: "2px dashed #DAE0E4",
                            borderRadius: "5px",
                            // padding: "5px",
                            position: "relative",
                          }}
                          onClick={selectLogo}
                        >
                          <Grid container direction={"column"} height={"100%"}>
                            <Grid
                              item
                              textAlign={"center"}
                              xs={8}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <PhotoSizeSelectActualIcon
                                style={{ fontSize: "30px", color: "#757575" }}
                              />
                              <Typography
                                fontWeight={"bold"}
                                fontSize={"14px"}
                                color={"#757575"}
                              >
                                نامه کسر از حقوق
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Box
                                width={"100%"}
                                height={"40px"}
                                sx={{
                                  backgroundColor: "#01AF43",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  position: "absolute",
                                  bottom: "0px",
                                  borderRadius: "0px 0px 5px 5px",
                                }}
                              >
                                <Typography color={"#fff"}>
                                  <AttachFileIcon /> بارگذاری عکس
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            width: "200px",
                            height: "120px",
                            border: "2px solid #DAE0E4",
                            borderRadius: "5px",
                            padding: "5px",
                          }}
                          onClick={selectLogo}
                        >
                          <img
                            alt="logo"
                            src={letterImage.preview}
                            width={"100%"}
                            height={"100%"}
                            style={{ objectFit: "contain" }}
                          />
                        </Box>
                      )}
                    </Grid>
                    <Grid
                      item
                      width={"100%"}
                      sx={{
                        position: "absolute",
                        bottom: "15px",
                        left: "25px",
                      }}
                    >
                      <Grid
                        container
                        flexDirection={"row"}
                        justifyContent={"end"}
                        gap={"1rem"}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          maxWidth={"150px !important"}
                        >
                          <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            disabled={
                              !values.companyName ||
                              !values.customerFirstName ||
                              !values.customerLastName ||
                              !values.customerNationalCode ||
                              letterImage === "" ||
                              !values.monthlyRepaymentPower
                            }
                            className={
                              !values.companyName ||
                                !values.customerFirstName ||
                                !values.customerLastName ||
                                !values.customerNationalCode ||
                                letterImage === "" ||
                                !values.monthlyRepaymentPower
                                ? "btnForm disabledBtn"
                                : "btnForm SuccessDefault"
                            }
                          >
                            ثبت
                          </Button>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={6}
                          maxWidth={"150px !important"}
                        >
                          <Button
                            fullWidth
                            variant="contained"
                            style={{
                              fontSize: "1rem",
                              color: "#fff",
                              height: "40px",
                              background: "#607D8B",
                            }}
                            onClick={() => {
                              history.push("/license/WhiteListHistory");
                            }}
                          >
                            بازگشت
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Grid>
          <Grid item md={2} lg={6}></Grid>
        </Grid>
      </Box>
      <span style={{ display: "none" }}>
        <DropzoneByClick
          inputRef={inputRef}
          size={20}
          picName={"تصویر مدرک"}
          display={false}
          acceptImage={true}
          onFileChoosed={(e: any) => {
            handleChoosedImage(e);
          }}
        />
      </span>
    </>
  );
};

export default AddCostumerToWhitelist;
